import Vue from 'vue'
import Resource from 'vue-resource'
Vue.use(Resource)
//
let actions = {
  parent: { // 用户登录
    'method': 'GET',
    'url': '/api/v1/organizations{/_id}/parent'
  },
  children: { // 用户注册
    'method': 'GET',
    'url': '/api/v1/organizations{/_id}/children'
  }
}

export default Vue.resource('/api/v1/organizations{/_id}', {}, actions)



// WEBPACK FOOTER //
// ./src/resource/organization.js